import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { UI_VERSION } from "../Constants";
import * as userService from "../actions/user.actions";
import * as authService from "../actions/auth.actions";

export default function showHomeOnboardingTour() {
  const driverObj = driver({
    showProgress: true,
    allowClose: false,
    steps: [
      {
        element: "#establish-stream-btn",
        popover: {
          title: "Let’s kick things off!",
          description: "Ready? Smash this button and your stream will begin.",
          side: "left",
          align: "start",
          onNextClick: () => {
            const startStreamBtn = document.querySelector(
              "#establish-stream-btn",
            );
            startStreamBtn?.click();
            driverObj.moveNext();
          },
        },
      },
      {
        element: ".stream-status",
        popover: {
          title: "Stream Status",
          description:
            "This is where you’ll see your stream status at a glance.",
          side: "bottom",
          align: "center",
        },
      },
      {
        element: "#qr-code-display",
        popover: {
          title: "Time to Scan the QR code",
          description: `Please scan this QR code using your phone's camera app`,
          side: "right",
          align: "end",
        },
      },
      {
        element: ".pairing-pin-input",
        popover: {
          title: "Your Pairing Pin",
          description: `Once you have completed the steps on the phone, you should now see your pairing pin here.
          `,
          side: "right",
          align: "end",
        },
      },
      {
        element: "#pair-btn",
        popover: {
          title: "Finally, Let's Connect!",
          description: "Time to pair with your mobile device.",
          side: "bottom",
          align: "center",
          onNextClick: () => {
            const pairBtn = document.querySelector("#pair-btn");
            pairBtn.click();
            if (
              document.querySelector(".pairing-pin-input").disabled === false
            ) {
              driverObj.moveTo(2);
            } else {
              driverObj.moveNext();
            }
          },
        },
      },
      {
        popover: {
          title: "Connection in progress!",
          description:
            "Your devices should be connecting right about now. Follow the instructions on your phone.",
          onNextClick: () => {
            userService.setUserUiOnboardingLevel(UI_VERSION);

            authService.reloadAuthToken();
            driverObj.destroy();
          },
        },
      },
    ],
  });
  setTimeout(() => {
    driverObj.drive();
  }, 1000);
}
